import { useQuery } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchZervantCustomDocumentTemplate } from '../query-api'

export const useZervantDocumentTemplateSettings = () => {
  const { data: documentTemplateData, ...rest } = useQuery(QueryKeys.ZervantDocumentTemplateSettings, () =>
    fetchZervantCustomDocumentTemplate(),
  )

  return { data: documentTemplateData?.data?.settings, ...rest }
}
